import React from 'react';
import { Box, Typography } from '@mui/material';

const LogoSlider = () => {
  // Company logos data
  const companyLogos = [
    { name: 'Delta', src: '/logo/delta_logo.png' },
    { name: 'Coca-Cola', src: '/logo/coke_logo.png' },
    { name: 'Dallas Mavericks', src: '/logo/mavericks_logo.png' },
    { name: 'Netflix', src: '/logo/netflix_logo.png' },
    { name: 'Shake Shack', src: '/logo/shake_shack_logo.png' },
    { name: 'Lexus', src: '/logo/lexus_logo.png' },
  ];

  return (
    <Box sx={{ width: '100%', py: 3 }}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 'var(--weight-medium)',
          textAlign: 'center',
          mb: 3,
          color: '#888888',
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          fontSize: { xs: '0.875rem', md: '1rem' },
        }}
      >
        Trusted By Industry Leaders
      </Typography>
      
      {/* Infinite Scrolling Logo Carousel */}
      <Box
        sx={{
          overflow: 'hidden',
          position: 'relative',
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            width: '100px',
            height: '100%',
            zIndex: 2,
            background: 'linear-gradient(to right, #000000, transparent)',
          },
          '&::after': {
            right: 0,
            background: 'linear-gradient(to left, #000000, transparent)',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            animation: 'scroll 30s linear infinite',
            width: 'calc(200px * 12)', // Adjust width to accommodate all logos
            '@keyframes scroll': {
              '0%': {
                transform: 'translateX(0)',
              },
              '100%': {
                transform: 'translateX(-50%)',
              },
            },
          }}
        >
          {/* Combined set of logos for seamless loop */}
          {[...companyLogos, ...companyLogos].map((logo, index) => (
            <Box
              key={index}
              sx={{
                minWidth: '200px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 1,
              }}
            >
              <img
                src={logo.src}
                alt={logo.name}
                style={{
                  maxHeight: '55px',
                  maxWidth: '160px',
                  objectFit: 'contain',
                  filter: 'brightness(0.7)',
                  transition: 'filter 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.filter = 'brightness(1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.filter = 'brightness(0.7)';
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default LogoSlider; 